import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})

export class SpinnerService {
    private requestCounter: number = 0;
    private requestInFlight$: BehaviorSubject<boolean>;
    private readonly pageOwnsLoader$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject<boolean>(false);
        this.pageOwnsLoader$ = new BehaviorSubject<boolean>(false);
    }
    setHttpStatus(inFlight: boolean) {
        if (inFlight) {
            this.requestCounter++;
        } else {
            this.requestCounter = Math.max(0, this.requestCounter - 1);
        }
        this.requestInFlight$.next(this.requestCounter > 0);
    }
    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
    /*Lets a page-level loader claim ownership so the global overlay doesn't double up with it*/
    setPageOwnsLoader(owns: boolean) {
        this.pageOwnsLoader$.next(owns);
    }
    getPageOwnsLoader(): Observable<boolean> {
        return this.pageOwnsLoader$.asObservable();
    }
}